import Script from 'next/script';
import { useEffect, useState } from 'react';

import Container from '@/components/elements/Container';
import Section from '@/components/elements/Section';

export default function JobPositions() {
  const [loaded, setLoaded] = useState(false);
  useEffect(() => {
    function listPositions() {
      if (loaded) {
        // @ts-ignore
        whr_embed(412665, {
          detail: 'titles',
          base: 'jobs',
          zoom: 'country',
          grouping: 'none',
        });
      }
    }
    listPositions();
  }, [loaded]);

  return (
    <>
      <Script
        strategy="beforeInteractive"
        src="https://www.workable.com/assets/embed.js"
        onReady={() => setLoaded(true)}
      />
      <Section>
        <Container>
          <div id="whr_embed_hook"></div>
        </Container>
      </Section>
    </>
  );
}
